import { APIService } from './APIService';

export const ValidateApp = (appname) => {
  return APIService({
      endpoint: "/app/",
      method: "GET",
      query: { name: appname } 
  });
};